module.exports = __webpack_public_path__ + "static/media/ya22.d4d72c9f.jpeg";